export default "__VITE_ASSET__AIumIU9z__"